import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-multiply-white",
  "use": "icon-multiply-white-usage",
  "viewBox": "0 0 8 7",
  "content": "<symbol fill=\"#fff\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 7\" id=\"icon-multiply-white\">\n  <path d=\"M.945 5.751l2.256-2.297L.96 1.164l.813-.84 2.25 2.29L6.27.323l.814.84-2.242 2.29 2.256 2.297-.814.84-2.263-2.303L1.76 6.592.945 5.75z\" fill=\"#fff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol